<template>
  <v-stepper-content step="6" class="pb-0">
    <v-alert
      v-if="timeLeft == 0 && $store.getters['game/timer']"
      class="animated bounceIn"
      type="error"
    >{{$t('general.timerMessage')}}</v-alert>

    <v-sheet
      class="text-center mb-1 card-title"
      color="primary"
      elevation="1"
      dark
    >{{$store.getters['company/productionCompany'] ? $t('steps.productionBatch') : $t('steps.supplierOrders')}}</v-sheet>
    <v-card class="pa-4" outlined :class="{'test-mode' : $store.getters['game/test']}">
      <v-row>
        <v-col cols="12">
          <v-alert
            v-if="$store.getters['company/data'].value.remains[$store.getters['company/data'].value.remains.length - 1] > 0"
            class="animated bounceIn"
            type="error"
          >{{$t('suppliersOrders.remainsAlert')}}</v-alert>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col cols="3" align="center" class="animated bounceInLeft delay-1s">
          <v-row v-if="$store.getters['company/productionCompany']" align="center">
            <v-col cols="12">
              <v-text-field
                min="0"
                type="number"
                outlined
                :label="$t('suppliersOrders.production')"
                :value="production"
                @input="checkMaxProduction($event)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-for="supplier in localSuppliers" v-else :key="supplier.data._id" align="center">
            <v-col cols="5">
              <v-text-field
                min="0"
                type="number"
                :value="supplier.orders"
                outlined
                :label="$t('suppliersOrders.orders')"
                @input="checkMax($event, supplier)"
              ></v-text-field>
            </v-col>
            <v-col cols="7" align="center">
              <company-logo
                :name="supplier.data.supplier.name"
                :logo="filesUrl + 'logo/' + supplier.data.supplier.companieSettings.logo"
              ></company-logo>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1" align="center" class="animated bounceInLeft delay-1s">
          <v-row>
            <v-col cols="12" align="center">
              <v-divider class="custom-divider"></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4" align="center" class="animated bounceIn">
          <v-row v-if="$store.getters['company/ddOn']">
            <v-col cols="12" align="center">
              <buffer
                v-if="step == 6"
                chartId="chartSupplierOrder"
                :renderBuffer="renderBuffer"
                :red="red"
                :yellow="yellow"
                :green="green"
                :flowEquation="flowEquation"
                :withFlowEquation="true"
              ></buffer>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" align="center">
              <v-img width="70%" src="@/assets/icon/commande fournisseur.png"></v-img>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="1" align="center" class="animated bounceInRight delay-1s">
          <v-row>
            <v-col cols="12" align="center">
              <v-divider class="custom-divider"></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" align="center" class="animated bounceInRight delay-1s">
          <v-row>
            <v-col cols="12" align="center">
              <company-logo
                :name="$store.getters['company/name']"
                :logo="filesUrl + 'logo/' + $store.getters['company/companySettings'].logo"
              ></company-logo>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col cols="12" align="center">
        <v-btn
          :class="{'animated heartBeat infinite slow' : readyForValidation && !$store.state.company.loading, 'animated bounceIn delay-2s': !readyForValidation}"
          color="primary"
          :disabled="!readyForValidation || $store.state.company.loading"
          @click="validate"
          :loading="$store.state.company.loading"
        >{{$store.getters['company/productionCompany'] ? $t('suppliersOrders.okProduction') : $t('suppliersOrders.ok')}}</v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="falseOrder" width="450">
      <v-alert type="error" class="mb-0">
        {{$t('dd.falseOrder')}}
        <v-btn icon @click="falseOrder = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-alert>
    </v-dialog>
  </v-stepper-content>
</template>

<script>
import { mapGetters } from "vuex";
import CompanyLogo from "@/components/CompanyLogo";
import Buffer from "@/components/Buffer";
export default {
  name: "SuppliersOrders",
  components: {
    CompanyLogo,
    Buffer
  },
  props: {
    step: Number,
    timeLeft: Number
  },
  data: () => ({
    falseOrder: false,
    localSuppliers: [],
    production: "",
    red: 0,
    yellow: 0,
    green: 0,
    flowEquation: 0,
    renderBuffer: false
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.production = "";
      this.localSuppliers = [];
      if (!this.$store.getters["company/productionCompany"]) {
        for (let supplier of this.$store.state.company.data.data.suppliers) {
          this.localSuppliers.push({
            data: Object.assign({}, supplier),
            orders: ""
          });
        }
      }
      if (this.$store.getters["company/ddOn"]) {
        this.renderBuffer = false;
        this.red = this.$store.getters["company/data"].dd.buffer.red[
          this.$store.getters["company/data"].dd.buffer.red.length - 1
        ];
        this.yellow = this.$store.getters["company/data"].dd.buffer.yellow[
          this.$store.getters["company/data"].dd.buffer.yellow.length - 1
        ];
        this.green = this.$store.getters["company/data"].dd.buffer.green[
          this.$store.getters["company/data"].dd.buffer.green.length - 1
        ];
        this.flowEquation = this.$store.getters[
          "company/data"
        ].dd.buffer.flowEquation[
          this.$store.getters["company/data"].dd.buffer.flowEquation.length - 1
        ];
        if (this.$store.getters['company/ddOrderPreFilled']) {
          this.autoAssignedDdOrders()
        }
        setTimeout(() => (this.renderBuffer = true), 1000);
      }
    },
    autoAssignedDdOrders() {
      if (this.$store.getters["company/productionCompany"]) {
        this.production = this.ddOrderSum >= 0 ? this.ddOrderSum : 0
      } else {
        let oneMore = false
        let perSupplierOrders = this.ddOrderSum / this.$store.state.company.data.data.suppliers.length
        if (perSupplierOrders % 1 !== 0) {
          oneMore = true
        }
        perSupplierOrders = Math.floor(perSupplierOrders)

        this.localSuppliers.forEach((supplier, index) => {
          supplier.orders = perSupplierOrders >= 0 ? perSupplierOrders : 0
          if (index == 1 && oneMore) {
            supplier.orders++
          }
        });
      }
    },
    checkDdValue() {
      let orders = 0;
      if (!this.$store.getters["company/productionCompany"]) {
        orders = this.localSuppliers.reduce(
          (prev, curr) => prev + curr.orders,
          0
        );
      } else {
        orders = this.production;
      }
      if (orders == this.ddOrderSum || (this.ddOrderSum < 0 && orders == 0)) {
        return true;
      } else {
        return false;
      }
    },
    async validate() {
      if (this.$store.getters["company/ddOn"] && !this.checkDdValue()) {
        this.falseOrder = true;
        return
      }
      if (!this.$store.getters["company/productionCompany"]) {
        let params = {
          orders: this.localSuppliers.map(supplier => {
            return {
              supplier: supplier.data.supplier._id,
              orders: supplier.orders
            };
          })
        };
        await this.$store.dispatch("company/suppliersOrders", params);
      } else {
        await this.$store.dispatch("company/productionBatch", {
          qte: this.production
        });
      }
    },

    async checkMax (val, supplier) {
      if (val > this.$store.getters['game/maxOrder']) {
        val = this.$store.getters['game/maxOrder']
      }
      supplier.orders = val
    },

    checkMaxProduction(val) {
      if (val > this.$store.getters['game/maxOrder']) {
        val = this.$store.getters['game/maxOrder']
      }
      this.production = val
    }
  },
  computed: {
    ddOrderSum() {
      if (this.flowEquation > this.red + this.yellow) {
        return 0
      } else {
        return this.red + this.yellow + this.green - this.flowEquation
      }
    },
    readyForValidation() {
      let answer = true;
      if (this.$store.getters["company/productionCompany"]) {
        if (this.production === "") {
          answer = false;
        }
      } else {
        this.localSuppliers.forEach(supplier => {
          if (supplier.orders === "") {
            answer = false;
          }
        });
      }
      return answer;
    },
    
    ...mapGetters("company", {
      filesUrl: "filesUrl"
    })
  },
  watch: {
    step(val) {
      if (val === 6) {
        this.init();
      }
    }
  }
};
</script>